export default "__VITE_ASSET__528e0b76__"